export const searchbarPlaceholder = 'search for an option by name...';
